import { render } from "./PricingModal.vue?vue&type=template&id=59840c57&scoped=true"
import script from "./PricingModal.vue?vue&type=script&lang=js"
export * from "./PricingModal.vue?vue&type=script&lang=js"

import "./PricingModal.vue?vue&type=style&index=0&id=59840c57&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59840c57"]])

export default __exports__